import { render, staticRenderFns } from "./AgendaItemList.vue?vue&type=template&id=21479526&"
import script from "./AgendaItemList.vue?vue&type=script&lang=ts&"
export * from "./AgendaItemList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports